import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from '@headlessui/react';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import CloseDialogButton from '@/dialogs_common/CloseDialogButton';

/**
 * Modal shell for this feature's dialogs. Headless UI's Dialog provides the
 * focus trap, Escape to close, aria-modal and labelling via Dialog.Title;
 * DialogTemplate/CloseDialogButton give it the app's existing dialog look.
 */
FeatureDialog.propTypes = {
  title: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  initialFocus: PropTypes.shape({ current: PropTypes.any }),
  children: PropTypes.node
};

export default function FeatureDialog(props) {
  const { title, onClose, initialFocus, children } = props;

  return (
    <Dialog open onClose={onClose} initialFocus={initialFocus} className="relative z-50">
      <div className="fixed inset-0 bg-black bg-opacity-25" aria-hidden="true" />
      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-start justify-center p-2 sm:p-8">
          <Dialog.Panel className="w-full max-w-screen-sm">
            <DialogTemplate className="w-full">
              <CloseDialogButton onCancel={onClose} />
              <div className="px-6 pt-6 pb-8 sm:px-8">
                <Dialog.Title as="h2" className="text-2xl font-semibold text-cs-gray-900 pr-10">
                  {title}
                </Dialog.Title>
                {children}
              </div>
            </DialogTemplate>
          </Dialog.Panel>
        </div>
      </div>
    </Dialog>
  );
}
